






















































































import Vue from 'vue';
import { mapState } from 'vuex';
import {
  Component, Prop, Watch, Inject,
} from 'vue-property-decorator';
import { ProductMappingResource, ProductMapping, CoreAccountProduct }
  from '@/api/productmapping/';
import { ProductTypeMap, ProductTypeDetails, NamePair }
  from '@/api/producttypes/';
import { Alert, NoticeClass } from '@kasasa/fbase-components/lib';
import { AccountProductTypeMap } from '@/api/accountproducttypes';

@Component({ computed: mapState(['fiId']) })
export default class ProductMappingDialog extends Vue {
    @Inject('ProductMappingResource')
    mappingResource!:ProductMappingResource;

    @Prop()
    mapping!:ProductMapping;

    @Prop()
    productTypeMap!:ProductTypeMap;

    @Prop()
    smallButton!:boolean;

    @Prop()
    coreAccountTypeMap!: Map<string, string[]>;

    @Prop()
    accountProductTypeMap!: AccountProductTypeMap;

    workingMapping:ProductMapping = ProductMappingDialog.createEmptyMapping();

    selectableCoreAccountTypes: string[] = [];

    selectableProductTypes: ProductTypeDetails[] = [];

    selectedProductType: ProductTypeDetails | null = null;

    fiId!:string;

    dialog:boolean = false;

    saving:boolean = false;

    isFormValid:boolean = false;

    productSubTypeItems: any[] = [];

    classificationItems: any[] = [];

    acquisitionSourceItems: any[] = [];

    initializeWorkingMapping() {
      if (this.mapping) {
        Object.assign(this.workingMapping, this.mapping);

        this.workingMapping.coreAccountProductTypes = [];
        for (let i = 0; i < this.mapping.coreAccountProductTypes.length; i++) {
          this.workingMapping.coreAccountProductTypes.push({
            id: null,
            coreAccountType: null,
            coreProductCode: null,
            linkedCoreAccountProduct: null,
            isCurrentlyLinked: false,
            lastQueryCount: null,
          });
          Object.assign(this.workingMapping.coreAccountProductTypes[i], this.mapping.coreAccountProductTypes[i]);
        }
      } else {
        this.workingMapping = ProductMappingDialog.createEmptyMapping();
      }

      this.selectedProductType = this.productTypeMap[this.workingMapping.productType!];
      this.initialiseSelectionLists();
    }

  isAsciiOnly = (str : string) => {
    for (let i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) > 127) {
        return false;
      }
    }
    return true;
  }

  initialiseSelectionLists() {
    this.productSubTypeItems = [];
    this.classificationItems = [{ text: 'None', value: null }];
    this.acquisitionSourceItems = [{ text: 'None', value: null }];
    if (this.selectedProductType && this.selectedProductType.productSubTypes && this.selectedProductType.productSubTypes.length > 0) {
      this.selectedProductType.productSubTypes.forEach((subType:NamePair) => {
        this.productSubTypeItems.push({
          text: subType.displayName,
          value: subType.name,
        });
      });

      this.selectedProductType.productClassifications.forEach((classification:NamePair) => {
        this.classificationItems.push({
          text: classification.displayName,
          value: classification.name,
        });
      });

      this.selectedProductType.productAcquisitionSources.forEach((acquisitionSource:NamePair) => {
        this.acquisitionSourceItems.push({
          text: acquisitionSource.displayName,
          value: acquisitionSource.name,
        });
      });
    }
  }

  static createEmptyMapping() : ProductMapping {
    return {
      id: null,
      coreAccountProductTypes: [ProductMappingDialog.createEmptyCoreAccountProduct()],
      accountType: null,
      productType: null,
      kasasaBranded: false,
      kasasaPowered: false,
      fiProductName: '',
      hasAssociatedAccounts: false,
      externalProductMappingId: null,
      productSubType: null,
      productAcquisitionSource: null,
      productClassification: null,
    };
  }

  static createEmptyCoreAccountProduct() : CoreAccountProduct {
    return {
      id: null,
      coreAccountType: null,
      coreProductCode: null,
      linkedCoreAccountProduct: null,
      isCurrentlyLinked: false,
      lastQueryCount: 0,
    };
  }

  requiredRule:Array<any> = [(value: any) => {
    if (!value || (Array.isArray(value) && value.length === 0)) {
      return 'Required';
    }
    return true;
  }];

  requiredAndAsciiRule:Array<any> = [(value: any) => {
    if (!value || (Array.isArray(value) && value.length === 0)) {
      return 'Required';
    }
    if (!this.isAsciiOnly(value)) {
      return 'Value has non-ascii characters';
    }
    return true;
  }];

  cancel() {
    const form: any = this.$refs.form;
    form.reset();
    this.dialog = false;
  }

  save() {
    this.saving = true;
    this.mappingResource.save(this.fiId, this.workingMapping).then((savedMapping:ProductMapping) => {
      if (this.mapping) {
        Object.assign(this.mapping, savedMapping);
      }

      this.$emit('success', savedMapping);
      this.dialog = false;
    })
      .catch((error:any) => {
        this.showError();
      })
      .finally(() => {
        this.saving = false;
      });
  }

    @Watch('dialog')
  onDialogToggle() {
    if (this.dialog) {
      this.saving = false;

      this.productSubTypeItems = [];

      this.initializeWorkingMapping();
    }
  }

    @Watch('workingMapping.accountType')
    onAccountTypeChange() {
      if (this.coreAccountTypeMap.has(this.workingMapping.accountType!)) {
        this.selectableCoreAccountTypes = this.coreAccountTypeMap.get(this.workingMapping.accountType!)!;

        const productTypes:string[]|undefined = this.accountProductTypeMap[this.workingMapping.accountType!];
        this.selectableProductTypes = [];
        let currentValid = false;
        if (productTypes) {
          productTypes.forEach((productType:string) => {
            this.selectableProductTypes.push(this.productTypeMap[productType]);
            if (productType === this.workingMapping.productType) {
              currentValid = true;
            }
          });

          if (!currentValid) {
            this.workingMapping.productType = null;
          }
        }
      } else {
        this.selectableCoreAccountTypes = [];
        this.selectableProductTypes = [];
        this.workingMapping.productType = null;
      }
    }

    onProductTypeChange() {
      if (this.workingMapping.productType === null) {
        this.selectedProductType = null;
      }

      this.workingMapping.productSubType = null;
      this.workingMapping.productClassification = null;
      this.workingMapping.productAcquisitionSource = null;

      this.selectedProductType = this.productTypeMap[this.workingMapping.productType!];

      if (!this.selectedProductType || !this.selectedProductType.kasasaPowered) {
        this.workingMapping.kasasaBranded = false;
      } else if (this.workingMapping.kasasaBranded) {
        this.workingMapping.fiProductName = this.selectedProductType.displayName;
      }

      this.initialiseSelectionLists();
    }

    onKasasaBrandedChange() {
      if (this.workingMapping.accountType !== 'LOAN') {
        if (this.workingMapping.kasasaBranded) {
          this.workingMapping.fiProductName = this.selectedProductType!.displayName;
        } else {
          this.workingMapping.fiProductName = '';
        }
      }
    }

    addNewCode() {
      this.workingMapping.coreAccountProductTypes.push(ProductMappingDialog.createEmptyCoreAccountProduct());
    }

    removeCode(index: number) {
      this.workingMapping.coreAccountProductTypes.splice(index, 1);
    }

    showError() {
      const al = new Alert('An unexpected error occurred.', NoticeClass.ERROR);
      al.setTimeout(5000);
		  this.$store.dispatch('notices/add', al);
	  }
}
